import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "@/lib/content";

const linkCls = ({ isActive }) =>
  `nav-link text-[0.72rem] font-medium uppercase tracking-[0.14em] transition-colors duration-300 ${
    isActive ? "text-gold is-active" : "text-ivory/80 hover:text-ivory"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b border-white/10 backdrop-blur-md transition-[background-color,padding] duration-500 ${
        scrolled ? "bg-navy/95 py-3" : "bg-navy/85 py-5"
      }`}
    >
      <div className="container-x flex items-center justify-between gap-6">
        <Link to="/" aria-label="MSK Hotels home" data-testid="header-logo-link">
          <Logo className="h-12 sm:h-14" />
        </Link>
        <nav className="hidden items-center gap-6 xl:gap-8 lg:flex" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`nav-link-${n.to.slice(1)}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-gold !px-6 !py-3" data-testid="nav-contact-button">
            Contact
          </Link>
        </nav>
        <button
          type="button"
          className="text-ivory lg:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>
      {open && (
        <nav className="mobile-menu container-x mt-4 flex flex-col gap-1 border-t border-white/10 pb-6 pt-4 lg:hidden" data-testid="mobile-menu">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => `py-3 font-display text-2xl ${isActive ? "text-gold" : "text-ivory"}`} data-testid={`mobile-nav-link-${n.to.slice(1)}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-gold mt-4 justify-center" data-testid="mobile-nav-contact-button">
            Contact MSK
          </Link>
        </nav>
      )}
    </header>
  );
};
